import { Box, Typography, Button, Stack, styled } from '@mui/material';

const AspectRatioButton = styled(Button)<{ selected: boolean; width: number; height: number }>(
  ({ theme, selected, width, height }) => ({
    minWidth: 'auto',
    padding: theme.spacing(1.5),
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: selected ? theme.palette.primary.main : theme.palette.grey[300],
    backgroundColor: selected ? `${theme.palette.primary.main}08` : 'transparent',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.75),
    '&:hover': {
      borderColor: selected ? theme.palette.primary.main : theme.palette.grey[400],
      backgroundColor: selected ? `${theme.palette.primary.main}15` : `${theme.palette.grey[300]}20`,
    },
    '& .aspect-box': {
      width: `${width}px`,
      height: `${height}px`,
      border: `2px solid ${selected ? theme.palette.primary.main : theme.palette.grey[400]}`,
      borderRadius: theme.shape.borderRadius,
    },
  })
);

interface AspectRatio {
  ratio: string;
  desc: string;
  width: number;
  height: number;
}

interface AspectRatioSelectorProps {
  value: string;
  onChange: (ratio: string) => void;
  ratios: AspectRatio[];
  label?: string;
}

const AspectRatioSelector = ({
  value,
  onChange,
  ratios,
  label = 'Aspect Ratio',
}: AspectRatioSelectorProps) => {
  return (
    <Box>
      <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 500 }}>
        {label}
      </Typography>
      <Stack direction="row" spacing={1.5}>
        {ratios.map(({ ratio, desc, width, height }) => (
          <AspectRatioButton
            key={ratio}
            selected={value === ratio}
            width={width}
            height={height}
            onClick={() => onChange(ratio)}
          >
            <Box className="aspect-box" />
            <Typography variant="caption" fontWeight={500}>
              {desc}
            </Typography>
          </AspectRatioButton>
        ))}
      </Stack>
    </Box>
  );
};

export default AspectRatioSelector;
